import React, { useEffect, useState } from "react";
import AttendanceRightsService from "../services/MenuProcessService";
import { toast } from "react-toastify";
import { useLoading } from "../Utils/LoadingContext";
import showToast from "../Utils/ToastContainer";
import "./TPLogin.css";

function AttendanceRights() {
    const [users, setUsers] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const { setLoading } = useLoading();

    const [form, setForm] = useState({
        employeeCode: "",
        isActive: true,
        createdBy: localStorage.getItem("empcode")
    });


    const loadRights = async () => {
        try {
            setLoading(true);
            const res = await AttendanceRightsService.getAttendanceUser();
            setUsers(res.data.result);
        } catch (err) {
            toast.error("Failed to load rights");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadRights();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleEdit = (row) => {
        setEditingId(row.id);
        setForm({
            employeeCode: row.employeeCode,
            isActive: row.isActive,
            createdBy: row.createdBy
        });
    };

    const handleSubmit = async () => {
        let payload = {
            id: editingId ?? 0,
            employeeCode: form.employeeCode,
            isActive: form.isActive,
            createdBy: form.createdBy
        };

        let res;
        if (editingId) {
            res = await AttendanceRightsService.updateAttendanceRight(payload);
        } else {
            res = await AttendanceRightsService.setAttendanceRight(payload);
        }

        if (res.data.statusCode === 200) {
            showToast(editingId ? "Rights updated" : "Rights granted", "success");
            resetForm();
            loadRights();
        }
    };

    const resetForm = () => {
        setForm({
            employeeCode: "",
            isActive: true,
            createdBy: localStorage.getItem("empcode")
        });
        setEditingId(null);
    };

    return (
        <div className="user-form">
            <h5>Attendance Rights Management</h5>

            <form className="horizontal-form">
                <div className="form-group">
                    <label>Employee Code</label>
                    <input
                        name="employeeCode"
                        value={form.employeeCode}
                        onChange={handleChange}
                        disabled={editingId}
                    />
                </div>

                <div className="form-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            name="isActive"
                            checked={form.isActive}
                            onChange={handleChange}
                        />
                        Active
                    </label>
                </div>

                <div className="form-group">
                    <button type="button" onClick={handleSubmit}>
                        {editingId ? "Update" : "Grant Rights"}
                    </button>
                </div>
            </form>

            <h5>Users With Rights</h5>
            <div className="table-wrapper">

                <table className="user-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>EmployeeCode</th>
                            <th>Active</th>
                            <th>CreatedBy</th>
                            <th>CreatedOn</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((u) => (
                            <tr key={u.id}>
                                <td>{u.id}</td>
                                <td>{u.employeeCode}</td>
                                <td>{u.isActive ? "Yes" : "No"}</td>
                                <td>{u.createdBy}</td>
                                <td>{new Date(u.createdOn).toLocaleString()}</td>
                                <td>
                                    <button onClick={() => handleEdit(u)}>Edit</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div></div>
    );
}

export default AttendanceRights;
